import React, { useCallback, useEffect, useState } from 'react';
import { LogOut } from 'lucide-react';
import { Container, Logo } from '../components/landing/shared';
import { AdminLogin } from '../components/admin/AdminLogin';
import { ApplicationsTable } from '../components/admin/ApplicationsTable';
import { SettingsForm } from '../components/admin/SettingsForm';
import { TOKEN_KEY } from '../components/admin/adminApi';

const TABS = [['applications', 'Bewerbungen'], ['settings', 'Einstellungen']];

export default function Admin() {
  const [authed, setAuthed] = useState(() => !!sessionStorage.getItem(TOKEN_KEY));
  const [tab, setTab] = useState('applications');

  useEffect(() => {
    document.title = 'Admin';
    const meta = Object.assign(document.createElement('meta'), { name: 'robots', content: 'noindex, nofollow' });
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  const logout = useCallback(() => { sessionStorage.removeItem(TOKEN_KEY); setAuthed(false); }, []);

  if (!authed) return <AdminLogin onLogin={() => setAuthed(true)} />;

  return (
    <div className="min-h-screen bg-paper pb-20 font-sans" data-testid="admin-page">
      <header className="bg-navy">
        <Container className="flex h-16 items-center justify-between">
          <Logo />
          <button onClick={logout} className="inline-flex min-h-[40px] items-center gap-2 rounded-full px-4 text-sm text-white/80 hover:text-white" data-testid="admin-logout-btn">
            <LogOut size={16} aria-hidden="true" /> Abmelden
          </button>
        </Container>
      </header>
      <Container className="mt-8">
        <div className="mb-8 inline-flex rounded-full border border-line bg-white p-1" role="tablist">
          {TABS.map(([key, label]) => (
            <button key={key} role="tab" aria-selected={tab === key} onClick={() => setTab(key)} data-testid={`admin-tab-${key}`}
                    className={`min-h-[44px] rounded-full px-5 text-sm font-semibold transition-colors ${tab === key ? 'bg-navy text-white' : 'text-ink hover:text-navy'}`}>
              {label}
            </button>
          ))}
        </div>
        {tab === 'applications' ? <ApplicationsTable onUnauthorized={logout} /> : <SettingsForm onUnauthorized={logout} />}
      </Container>
    </div>
  );
}
